import { BaseModel } from './base.model';
import { Department } from './department.model';
import { Contact } from './contact.model';
import { Client } from './client.model'; // NUEVO 1a

export interface Society {
    id: number;
    name: string;
    country: string;
    city: string;
    address: string;
    phoneNumber: string;
    departments: Department[];
    contacts: Contact[];
    client: Client; // NUEVO 1a: el endpoint backend ya lo devuelve (societyService.js)
}

export class Society implements BaseModel {
  id: number;
  name: string;
  country: string;
  city: string;
  address: string;
  phoneNumber: string;
  departments: Department[];
  contacts: Contact[];
  client: Client; // NUEVO 1a

  constructor();
  constructor(id: number, name: string, country: string, city: string, address: string, phoneNumber: string, departments: Department[], contacts: Contact[], client: Client);

  constructor(id?: number, name?: string, country?: string, city?: string, address?: string, phoneNumber?: string, departments?: Department[], contacts?: Contact[], client?: Client) {
    if (id !== undefined) {
      this.id = id;
    }
    if (name !== undefined) {
      this.name = name;
    } else {
      this.name = '';
    }

    if (country !== undefined) {
      this.country = country;
    } else {
      this.country = '';
    }

    if (city !== undefined) {
      this.city = city;
    } else {
      this.city = '';
    }

    if (address !== undefined) {
      this.address = address;
    } else {
      this.address = '';
    }

    if (phoneNumber !== undefined) {
      this.phoneNumber = phoneNumber;
    } else {
      this.phoneNumber = '';
    }

    if (departments !== undefined) {
      this.departments = departments;
    } else {
      this.departments = [];
    }

    if (contacts !== undefined) {
      this.contacts = contacts;
    } else {
      this.contacts = [];
    }

    // NUEVO 1a
    if (client !== undefined) {
      this.client = client;
    } else {
      this.client = {} as Client;
    }
  }

  getApiName(): string {
    return 'societies';
  }

  getName(): string {
    return 'Sociedad';
  }

  getNamePl(): string {
    return 'Sociedades';
  }
}